export const messageConstants = {
    CREATE_MESSAGE_REQUEST: 'MESSAGE_CREATE_REQUEST',
    CREATE_MESSAGE_SUCCESS: 'MESSAGE_CREATE_SUCCESS',
    CREATE_MESSAGE_FAILURE: 'MESSAGE_CREATE_FAILURE',
};
